import * as React from "react";
import { ComponentClass } from "react";
import { AdminActions, IAdminStore } from "../store/admin";
import { IStore } from "../store";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";
import { getApi } from "../api/ApiProvider";

// material
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { SortDirection } from "@material-ui/core/TableCell";
import Grid from "@material-ui/core/Grid";
import { Theme, WithStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";

// utils
import { bindActions, mockTheme } from "../utils/utils";

// components
import EnhancedSchemaForm from "../components/schemaForm";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { BranchData } from "../components/BranchSelector";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  disableIcon: {
    color: red[900],
  },
  enableIcon: {
    color: green[900],
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface AdminsProps extends WithStyles<keyof typeof classesType> {
  actions: AdminActions;
  data: IAdminStore;
  user: any;
}

interface AdminsState {
  schemaAdmin: any;
  duplicateAdmin: boolean;
  abm: {
    name: string;
    document: string;
    email: string;
    open: boolean;
    branch: number;
    state: string;
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
}

const schema: JSONSchema6 = {
  title: "Administrador",
  type: "object",
  required: ["name", "pass", "email", "branch"],
  properties: {
    name: { type: "string", title: "Nombre" },
    email: { type: "string", title: "Correo electrónico", format: "email" },
    pass: { type: "string", title: "Contraseña" },
    branch: {
      type: "number",
      title: "Sucursal",
      anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
      default: 0,
    },
  },
};

const uiSchema: UiSchema = {
  pass: {
    "ui:widget": "password",
    "ui:help": "Usa un password complejo",
  },
};

class Admins extends React.Component<
  AdminsProps,
  AdminsState,
  { schema: any }
> {
  constructor(props: AdminsProps) {
    super(props);

    this.state = {
      schemaAdmin: schema,
      duplicateAdmin: false,
      abm: {
        name: "",
        document: "",
        email: "",
        branch: 0,
        open: false,
        state: "",
      },
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          {
            path: "user.name",
            numeric: false,
            disablePadding: true,
            label: "Nombre",
          },
          {
            path: "user.email",
            numeric: false,
            disablePadding: false,
            label: "Correo",
          },
          {
            path: "user.state",
            numeric: false,
            disablePadding: false,
            label: "Estado",
          },
          {
            path: "branch.name",
            numeric: false,
            disablePadding: false,
            label: "Sucursal",
          },
          {
            path: "",
            numeric: false,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: AdminsProps) => {
              return (
                <div>
                  <IconButton
                    className={
                      data.user.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                    onClick={
                      data.user.state === "ACTIVE"
                        ? this.handleDisable(data)
                        : this.handleActivate(data)
                    }
                  >
                    {data.user.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
  }

  validAdmin(dataAdmin: any) {
    const admins = this.props.data.data.data;
    const data = {
      name: dataAdmin.name,
      email: dataAdmin.email,
    };

    const filterAdmins = admins.filter(
      (a: { user: { email: string; name: string } }) => {
        const { name, email } = a.user;
        return email === data.email || name === data.name;
      }
    );

    if (filterAdmins.length) {
      return false;
    } else {
      return true;
    }
  }

  fillBranchInSchema() {
    const companyId = this.props.user.companyId;

    getApi()
      .branch()
      .listAllBranchesCompany(companyId)
      .then((dataB: BranchData[]) => {
        const newSchema2: JSONSchema6 = JSON.parse(JSON.stringify(schema));
        const branch = newSchema2.properties!.branch as JSONSchema6;

        branch.anyOf = dataB.map((d) => {
          return {
            type: "number",
            enum: [d.id],
            title: d.name || "",
          } as JSONSchema6;
        });

        this.setState({ schemaAdmin: newSchema2 });
      });
  }

  handleSubmit(e: ISubmitEvent<any>) {
    const valid = this.validAdmin(e.formData);

    if (valid) {
      this.props.actions.addExtended(e.formData);
      this.hideDialog();
    } else {
      this.setState({ duplicateAdmin: true });
      setTimeout(() => {
        this.setState({ duplicateAdmin: false });
      }, 3000);
    }
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  handleDisable(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.disable(data);
    };
  }
  handleActivate(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.activate(data);
    };
  }

  componentDidMount() {
    this.props.actions.fetch();
  }

  hideDialog() {
    this.setState({
      abm: {
        ...this.state.abm,
        open: false,
      },
      duplicateAdmin: false,
    });
  }

  showDialog() {
    this.setState(
      {
        abm: {
          name: "",
          email: "",
          document: "",
          branch: 0,
          open: true,
          state: "",
        },
        duplicateAdmin: false,
      },
      () => {
        this.fillBranchInSchema();
      }
    );
  }

  render() {
    return (
      <Grid container spacing={24}>
        <Grid item sm={12} md={12} lg={12}>
          <AsyncTable
            columnDefinition={this.state.table.columnData}
            title="Administradores"
            data={this.props.data.data.data}
            defaultOrder={{
              name: "name",
              direction: "desc",
            }}
            headerButtons={
              <Tooltip title="Agregar">
                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </Grid>
        <Dialog open={this.state.abm.open} maxWidth="md" fullWidth={true}>
          <Paper className={this.props.classes.abm}>
            <EnhancedSchemaForm
              schema={this.state.schemaAdmin}
              onSubmit={this.handleSubmit}
              uiSchema={uiSchema}
            >
              {this.state.duplicateAdmin && (
                <div style={{ marginBottom: 15 }}>
                  <strong>
                    El usuario o correo ya existe. Verifique sus datos...{" "}
                  </strong>
                </div>
              )}
              <div>
                <Button variant="contained" onClick={this.hideDialog}>
                  Cancelar
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Aceptar
                </Button>
              </div>
            </EnhancedSchemaForm>
          </Paper>
        </Dialog>
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: AdminsProps) => ({
  ...ownProps,
  data: state.admin,
  user: state.auth.user,
});

const styled = withStyles(styles as any)(Admins);
const connected = connect(mapStateToProps, bindActions(AdminActions))(styled);

export default connected as ComponentClass<Partial<AdminsProps>>;



// WEBPACK FOOTER //
// ./src/pages/admin.tsx